export default __webpack_public_path__ + "static/media/Info_Center_App_Icon.b04fcc08.svg";